module.exports = __webpack_public_path__ + "img/google-play.f0090b44.png";